module.exports = __webpack_public_path__ + "static/media/spectrum.00b8dcb1.svg";